// extracted by mini-css-extract-plugin
export default {"tabs__titles":"Tabs_tabs__titles__I2yC4","tabs__title":"Tabs_tabs__title__4kbUs","active":"Tabs_active__hC6rb"};